import { render, staticRenderFns } from "./compass-sun.svg.vue?vue&type=template&id=0ed01c9c&"
import script from "./compass-sun.svg.vue?vue&type=script&lang=js&"
export * from "./compass-sun.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports